import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import { AccordionComponent } from '@interacta-shared/ui';
import { NormalizedLinkSection } from '../../models/external-link.model';
import { LinkCardComponent } from '../link-card/link-card.component';

@Component({
    selector: 'interacta-links-dialog-section',
    templateUrl: './links-dialog-section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AccordionComponent, LinkCardComponent],
})
export class LinksDialogSectionComponent {
    readonly section = input.required<NormalizedLinkSection>();
    readonly isOpen = input.required<boolean>();

    readonly toggleAccordion = output<string>();
    readonly loadError = output<string>();
    readonly linkActivated = output<void>();
}
